var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { CustomPriceRow } from "../../admin/CustomPriceRow";
import { Grid, Select } from "semantic-ui-react";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import ErrorDisplay from "../../ErrorDisplay";
import { uniqueBy } from "../rna-fish/ProbeSetForm";
import { priceColumn, PriceDisplay } from "../rna-fish/EditKitForm";
var ChromogenForm = /** @class */ (function (_super) {
    __extends(ChromogenForm, _super);
    function ChromogenForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onChromogenChange = function (_, data) {
            var valStr = data.value;
            var chromogen = _this.props.catalog.chromogens
                .concat([{ id: 'NONE', label: 'NONE', protocolCompatibility: [], enzymeCompatibility: '', bufferCompatibility: { id: 'NONE', label: 'NONE' } }])
                .find(function (c) { return c.id === valStr; });
            if (chromogen === undefined) {
                throw new RangeError("Invalid  chromogen " + valStr);
            }
            if (_this.props.nonOtherKit) {
                _this.props.onChromogenChange({
                    chromogen: chromogen,
                    chromogenBuffer: chromogen.id === "NONE" ? { id: "NONE", label: "NONE" } : chromogen.bufferCompatibility,
                    chromogenScaleSlides: chromogen.id === "NONE" ? 0 : _this.props.allScales,
                    chromogenBufferScaleSlides: chromogen.id === "NONE" ? 0 : _this.props.allScales,
                    hematoxylinScaleSlides: chromogen.id === "NONE" ? 0 : _this.props.allScales
                }, _this.props.onUserSelection);
            }
            else {
                _this.props.onChromogenChange({
                    chromogen: chromogen,
                    chromogenScaleSlides: chromogen.id === "NONE" ? 0 : _this.props.chromogenState.chromogenScaleSlides,
                }, _this.props.onUserSelection);
            }
        };
        _this.onChromogenBufferChange = function (_, data) {
            var valStr = data.value;
            var chromogenBuffer = _this.props.catalog.chromogenBuffers
                .concat([{ id: 'NONE', label: 'NONE' }])
                .find(function (c) { return c.id === valStr; });
            if (chromogenBuffer === undefined) {
                throw new RangeError("Invalid  chromogen buffer " + valStr);
            }
            _this.props.onChromogenChange({
                chromogenBuffer: chromogenBuffer,
                chromogenBufferScaleSlides: chromogenBuffer.id === 'NONE' ? 0 : _this.props.chromogenState.chromogenBufferScaleSlides
            }, _this.props.onUserSelection);
        };
        _this.onChromogenScaleChange = function (_, data) {
            var v = data.value;
            var chromogen = v === 0 ? {
                id: 'NONE',
                label: 'NONE',
                protocolCompatibility: [],
                enzymeCompatibility: '',
                bufferCompatibility: { id: 'NONE', label: 'NONE' }
            } : _this.props.chromogenState.chromogen;
            _this.props.onChromogenChange({
                chromogenScaleSlides: v,
                chromogen: chromogen
            }, _this.props.onUserSelection);
        };
        _this.onChromogenBufferScaleChange = function (_, data) {
            var v = data.value;
            var chromogenBuffer = v === 0 ? {
                id: "NONE",
                label: "NONE"
            } : _this.props.chromogenState.chromogenBuffer;
            _this.props.onChromogenChange({
                chromogenBufferScaleSlides: v,
                chromogenBuffer: chromogenBuffer
            }, _this.props.onUserSelection);
        };
        _this.onHematoxylinScaleChange = function (_, data) {
            var v = data.value;
            _this.props.onChromogenChange({
                hematoxylinScaleSlides: v
            }, _this.props.onUserSelection);
        };
        _this.chromogenScaleSlideOptions = function () {
            return uniqueBy(_this.props.catalog.proChromogenScales
                .concat(_this.props.chromogenState.chromogenScaleSlides), function (s) { return s; });
        };
        _this.chromogenBufferScaleSlideOptions = function () {
            return uniqueBy(_this.props.catalog.proChromogenScales
                .concat(_this.props.chromogenState.chromogenBufferScaleSlides), function (s) { return s; });
        };
        _this.hematoxylinScaleSlideOptions = function () {
            return uniqueBy(_this.props.catalog.proChromogenScales
                .concat(_this.props.chromogenState.hematoxylinScaleSlides), function (s) { return s; });
        };
        _this.checkChromogenCompatibility = function (chromogen) {
            if (_this.props.nonOtherKit) {
                return chromogen.protocolCompatibility.some(function (p) { return p.id === _this.props.protocolType.id; }) &&
                    (_this.props.ampState.antiHapten2Ap.label != 'NONE' && chromogen.enzymeCompatibility === 'AP' ||
                        _this.props.ampState.antiHapten2Hrp.label != 'NONE' && chromogen.enzymeCompatibility === 'HRP');
            }
            else {
                return chromogen.protocolCompatibility.some(function (p) { return p.id === _this.props.protocolType.id; });
            }
        };
        _this.checkChromogenBufferCompatibility = function (chromogenBuffer) {
            if (_this.props.nonOtherKit || _this.props.chromogenState.chromogen.id !== 'NONE') {
                return _this.props.chromogenState.chromogen.bufferCompatibility.id === chromogenBuffer.id;
            }
            else {
                return true;
            }
        };
        _this.onCustomPriceChange = function (newStateFn, callback) {
            _this.props.onChromogenChange(function (oldState) {
                return {
                    customPrice: newStateFn(oldState.customPrice)
                };
            }, callback);
        };
        return _this;
    }
    ChromogenForm.prototype.render = function () {
        var _this = this;
        var _a, _b;
        return React.createElement(React.Fragment, null,
            React.createElement(Grid, { columns: 3, stackable: true },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/chromogenComponent/chromogen', labelContent: 'Chromogen', labelFor: 'chromogen' },
                            React.createElement(Select, { name: 'chromogen', onChange: this.onChromogenChange, options: this.props.catalog.chromogens.filter(function (c) {
                                    return _this.checkChromogenCompatibility(c);
                                }).map(function (c) {
                                    return {
                                        text: c.label,
                                        value: c.id
                                    };
                                }).concat([{ text: 'NONE', value: 'NONE' }]), value: this.props.chromogenState.chromogen.id }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/chromogenComponent/chromogenBuffer', labelContent: 'Chromogen Buffer', labelFor: 'chromogen-buffer', disabled: this.props.lockScales },
                            React.createElement(Select, { name: 'chromogen-buffer', onChange: this.onChromogenBufferChange, options: this.props.catalog.chromogenBuffers.filter(function (c) {
                                    return _this.checkChromogenBufferCompatibility(c);
                                }).map(function (c) {
                                    return {
                                        text: c.label,
                                        value: c.id
                                    };
                                }).concat([{ text: 'NONE', value: 'NONE' }]), value: this.props.chromogenState.chromogenBuffer.id })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/chromogenComponent/chromogenScaleSlides', labelContent: React.createElement(React.Fragment, null, "Chromogen Scale"), labelFor: 'chromogen-slides', disabled: this.props.lockScales },
                            React.createElement(Select, { disabled: this.props.lockScales, name: 'chromogen-slides', onChange: this.onChromogenScaleChange, options: this.chromogenScaleSlideOptions().map(function (s) {
                                    return {
                                        text: s,
                                        value: s
                                    };
                                }), search: true, value: this.props.chromogenState.chromogenScaleSlides }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/chromogenComponent/chromogenBufferScaleSlides', labelContent: React.createElement(React.Fragment, null, "Chromogen Buffer Scale"), labelFor: 'chromogen-buffer-slides', disabled: this.props.lockScales },
                            React.createElement(Select, { disabled: this.props.lockScales, name: 'chromogen-buffer-slides', onChange: this.onChromogenBufferScaleChange, options: this.chromogenBufferScaleSlideOptions().map(function (s) {
                                    return {
                                        text: s,
                                        value: s
                                    };
                                }), search: true, value: this.props.chromogenState.chromogenBufferScaleSlides }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/chromogenComponent/hematoxylinScaleSlides', labelContent: React.createElement(React.Fragment, null, "Hematoxylin Scale"), labelFor: 'hematoxylin-slides', disabled: this.props.lockScales },
                            React.createElement(Select, { disabled: this.props.lockScales, name: 'hematoxylin-slides', onChange: this.onHematoxylinScaleChange, options: this.hematoxylinScaleSlideOptions().map(function (s) {
                                    return {
                                        text: s,
                                        value: s
                                    };
                                }), search: true, value: this.props.chromogenState.hematoxylinScaleSlides })))),
                this.props.chromogenComponent &&
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(React.Fragment, null, (_a = this.props.chromogenComponent.chromogen) === null || _a === void 0 ? void 0 : _a.label),
                            React.createElement("br", null),
                            this.props.chromogenComponent.chromogenScale.volumeScaleMl + " mL"),
                        React.createElement(Grid.Column, null,
                            React.createElement(React.Fragment, null, (_b = this.props.chromogenComponent.chromogenBuffer) === null || _b === void 0 ? void 0 : _b.label),
                            React.createElement("br", null),
                            this.props.chromogenComponent.chromogenBufferScale.volumeScaleMl + " mL"),
                        React.createElement(Grid.Column, null,
                            React.createElement(React.Fragment, null, "Hematoxylin"),
                            React.createElement("br", null),
                            this.props.chromogenComponent.hematoxylinScale.volumeScaleMl + " mL"))),
            React.createElement(Grid, { columns: 4, stackable: true },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null),
                    React.createElement(Grid.Column, null),
                    React.createElement(Grid.Column, null),
                    priceColumn(React.createElement(PriceDisplay, { loading: this.props.priceLoading, priceCents: this.props.priceCents }))),
                this.props.enableCustomPrice &&
                    React.createElement(CustomPriceRow, { customPrice: this.props.chromogenState.customPrice, defaultEffectivePriceCents: this.props.priceCents, errors: this.props.errors, errorPathPrefix: '/chromogenComponent', onPriceChange: this.onCustomPriceChange, onUserInput: this.props.onUserSelection })),
            React.createElement(ErrorDisplay, { errors: this.props.errors, errorPath: "/chromogenComponent" }));
    };
    return ChromogenForm;
}(React.PureComponent));
export default ChromogenForm;
//# sourceMappingURL=ChromogenForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-cish/ChromogenForm.js
// module id = 550
// module chunks = 0